import React from 'react';
import { PATH_DASHBOARD } from '../../../routes/paths';
import SvgIconStyle from '../../../components/SvgIconStyle';

const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

/**
 * Sidebar items shown only when `admin.role` is `super-admin`.
 * Each item needs `modulePath` equal to the first segment after `/admin/` (AuthGuard uses this).
 */
export function getSuperAdminNavItems() {
  return [
    {
      title: 'Dashboard',
      path: PATH_DASHBOARD.adminDashboard.root,
      icon: getIcon('ic_employees'),
      modulePath: 'adminDashboard',
    },
    {
      title: 'Module Access',
      path: PATH_DASHBOARD.moduleAccess.root,
      icon: getIcon('package_management'),
      modulePath: 'moduleAccess',
    },
    { title: 'Profile', path: PATH_DASHBOARD.profile.root, icon: getIcon('ic_vendors'), modulePath: 'profile' },
  ];
}
